// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid white;
  padding: 1rem;
  gap: 2rem;
}
.settings__photo-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3vw;
}
.settings__photo-section__titles {
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
  font-size: 0.85rem;
}
.settings__photo-section__titles__primary {
  font-weight: 500;
  color: black;
}
.settings__photo-section__titles__secondary {
  color: #5B5656;
  font-weight: 400;
}
.settings__photo-section__photo {
  height: 5vw;
  width: 5vw;
}
.settings__photo-section__controls {
  display: flex;
  gap: 1vw;
  font-weight: 500;
  font-size: 0.85rem;
  cursor: pointer;
}
.settings__photo-section__controls__delete {
  color: #5B5656;
}
.settings__photo-section__controls__update {
  color: #4F4BFF;
}
.settings__form-section {
  display: flex;
  flex-direction: column;
  gap: 2vh;
}
.settings__form-section__title {
  color: black;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 2vh;
}
.settings__form-section__row {
  display: grid;
  grid-template-columns: 10vw 25vw;
  flex-direction: row;
  gap: 10%;
  justify-content: start;
  align-items: center;
}
.settings__controls {
  margin-top: 6vh;
  display: flex;
  width: 80%;
  flex-direction: row;
  justify-content: end;
  height: fit-content;
  gap: 0.5rem;
}
.settings__controls__save {
  width: fit-content;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.settings__controls__cancel {
  width: fit-content;
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.settings__separator {
  width: 80%;
  height: 1px;
  background-color: #DBDBDB;
}
.settings .text-input {
  width: 100%;
  border-radius: 3px;
}
.settings .input-label {
  color: #494949;
  font-weight: 500;
  font-size: 0.85rem;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/settings/settings.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AACR;AAAQ;EACI,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AAEZ;AADY;EACI,gBAAA;EACA,YAAA;AAGhB;AADY;EACI,cAAA;EACA,gBAAA;AAGhB;AAAQ;EACI,WAAA;EACA,UAAA;AAEZ;AAAQ;EACI,aAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAEZ;AADW;EACK,cAAA;AAGhB;AAAW;EACK,cAAA;AAEhB;AAEI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAAR;AACQ;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AACZ;AACQ;EACI,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,mBAAA;AACZ;AAEI;EACI,eAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAAR;AACQ;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AACZ;AAEQ;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAAZ;AAGI;EACI,UAAA;EACA,WAAA;EACA,yBAAA;AADR;AAGI;EACI,WAAA;EACA,kBAAA;AADR;AAII;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AAFR;;AAMA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AAHJ;;AAMA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AAHJ","sourcesContent":[".settings {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    border: 1px solid white;\n    padding: 1rem;\n    gap: 2rem;\n\n    &__photo-section{\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 3vw;\n        &__titles{\n            display: flex;\n            flex-direction: column;\n            gap: 0.5vh;\n            font-size: 0.85rem;\n            &__primary{\n                font-weight: 500;\n                color: black;\n            }\n            &__secondary{\n                color: #5B5656;\n                font-weight: 400;\n            }\n        }\n        &__photo{\n            height: 5vw;\n            width: 5vw;\n        }\n        &__controls{\n            display: flex;\n            gap: 1vw;\n            font-weight: 500;\n            font-size: 0.85rem;\n            cursor: pointer;\n           &__delete{\n                color: #5B5656;\n\n           }\n           &__update{\n                color: #4F4BFF;\n           }\n        }\n    }\n    &__form-section{\n        display: flex;\n        flex-direction: column;\n        gap: 2vh;\n        &__title{\n            color: black;\n            font-weight: bold;\n            font-size: 1rem;\n            margin-bottom: 2vh;\n        }\n        &__row{\n            display: grid;\n            grid-template-columns: 10vw 25vw;\n            flex-direction: row;\n            gap: 10%;\n            justify-content: start;\n            align-items: center;\n        }\n    }\n    &__controls{\n        margin-top: 6vh;\n        display: flex;\n        width: 80%;\n        flex-direction: row;\n        justify-content: end;\n        height: fit-content;\n        gap: 0.5rem;\n        &__save{\n            width: fit-content;\n            height: 40px;\n            background-color:#4F4BFF;\n            color: white;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n        }\n\n        &__cancel{\n            width: fit-content;\n            height: 40px;\n            background-color:transparent;\n            color: black;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n        }\n    }\n    &__separator{\n        width: 80%;\n        height: 1px;\n        background-color: #DBDBDB;\n    }\n    .text-input{\n        width: 100%;\n        border-radius: 3px;\n\n    }\n    .input-label{\n        color: #494949;\n        font-weight: 500;\n        font-size: 0.85rem;\n    }\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
